import styles from 'sections/aboutUs/aboutUsHero/aboutUsHero.module.css';
import generalStyles from 'index.module.css';

import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { AnimatedPart } from 'components/animatedPart/AnimatedPart';
import { LogoBeige } from 'components/vectors/LogoBeige';
import { useRedirectToHome } from 'hooks/redirect.hooks';

export const AboutUsHero = () => {
    const { t } = useTranslation();
    const redirectToHome = useRedirectToHome();

    return (
        <section
            id="section-about-us-hero"
            className={`${generalStyles.heightAuto} ${styles.aboutUsSection}`}
        >
            <Element name="aboutUsHero">
                <div className={styles.aboutUs}>
                    <div className={styles.text}>
                        <AnimatedPart>
                            <h1 className={`${styles.heading} animated-items`}>
                                {t('aboutUs.aboutUsTitle')}
                            </h1>
                        </AnimatedPart>
                    </div>
                </div>

                <div className={generalStyles.container}>
                    <div className={styles.aboutUs__info}>
                        <div
                            className={styles.info__logo}
                            onClick={redirectToHome}
                        >
                            <LogoBeige />
                        </div>
                        <p className={styles.info__text}>
                            {t('aboutUs.lesFemmesIsAPerformanceGroup')}
                        </p>
                    </div>
                </div>
            </Element>
        </section>
    );
};
